import React, { useState, useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import { NotFoundAnim } from "../../assets";
import Animation from "../../shared/components/common/Animation";
import { GetOffers } from "../../shared/services/offerService";
import OfferCard2 from "./offerCard2";
import OfferCard from "./offersCard";
import "./style.css";

function Offers() {
  const user = useSelector((state) => state.root.user);
  const [offersList, setOffersList] = useState(null);
  const [loader, setLoader] = useState(false);
  const getAllOffers = async () => {
    setOffersList(null);
    setLoader(true);
    await GetOffers(user?.token)
      .then((res) => {
        if (res.statusText === "OK") {
          console.log(res.data);
          setOffersList(res.data);
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        setLoader(false);
      });
  };
  useEffect(() => {
    getAllOffers();
  }, []);
  return (
    <div
      className="container offer-main-container"
      data-aos="fade-up"
      data-aos-duration="500"
    >
      <h2 className="driptivity-text">Offers</h2>
      {loader ? (
        <div className="d-flex align-items-center flex-column pt-3 pad-bt">
          <Spinner animation="grow" size="lg" />
        </div>
      ) : offersList && offersList.length > 0 ? (
        offersList?.map((item, key) => {
          return item?.type === 1 ? (
            <OfferCard key={key} item={item} reload={getAllOffers} />
          ) : (
            <OfferCard2 key={key} item={item} reload={getAllOffers} />
          );
        })
      ) : (
        <div className="pb-5 animation-container">
          <Animation Pic={NotFoundAnim} Message={"No Offers Found"} />
        </div>
      )}
    </div>
  );
}

export default Offers;
